import type * as Types from 'app/types/graphql';

import {
  SubscriptionTrialUsageEdgeSelectFragmentDoc,
  SubscriptionTrialUsageSelectFragmentDoc,
} from '../fragments/subscriptionTrialUsage.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type SubscriptionTrialUsagesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where: Types.SubscriptionTrialUsageWhereInput;
}>;

export type SubscriptionTrialUsagesQueryResponse = {
  subscriptionTrialUsages?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<
        Pick<Types.SubscriptionTrialUsageEdge, 'cursor'> & {
          node?: Types.Maybe<
            Pick<
              Types.SubscriptionTrialUsage,
              'id' | 'shopPlatformID' | 'planID' | 'trialDays' | 'usedTrialDays'
            >
          >;
        }
      >
    >;
  }>;
};

export const SubscriptionTrialUsagesDocument = `
    query SubscriptionTrialUsages($first: Int, $where: SubscriptionTrialUsageWhereInput!) {
  subscriptionTrialUsages(first: $first, where: $where) {
    edges {
      ...SubscriptionTrialUsageEdgeSelect
    }
  }
}
    ${SubscriptionTrialUsageEdgeSelectFragmentDoc}
${SubscriptionTrialUsageSelectFragmentDoc}`;

export const useSubscriptionTrialUsagesQuery = <
  TData = SubscriptionTrialUsagesQueryResponse,
  TError = unknown,
>(
  variables: SubscriptionTrialUsagesQueryVariables,
  options?: UseQueryOptions<SubscriptionTrialUsagesQueryResponse, TError, TData>,
) => {
  return useQuery<SubscriptionTrialUsagesQueryResponse, TError, TData>(
    ['SubscriptionTrialUsages', variables],
    appFetcher<SubscriptionTrialUsagesQueryResponse, SubscriptionTrialUsagesQueryVariables>(
      SubscriptionTrialUsagesDocument,
      variables,
    ),
    options,
  );
};

useSubscriptionTrialUsagesQuery.getKey = (variables: SubscriptionTrialUsagesQueryVariables) => [
  'SubscriptionTrialUsages',
  variables,
];
